export default "__VITE_ASSET__CXpPY6jy__"